module.exports = __webpack_public_path__ + "img/avax.96cbf3e8.svg";